import { createFileRoute } from '@tanstack/react-router';
import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';

export const Route = createFileRoute('/about')({ component: AboutPage });

function AboutPage() {
  const [text, setText] = useState(''), [error, setError] = useState(false), [attempt, setAttempt] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    setError(false); setText('');
    void fetch('/THIRD-PARTY-NOTICES.txt', { signal: controller.signal }).then(async (response) => {
      if (!response.ok) throw new Error('Notices unavailable');
      const value = await response.text();
      if (!value.startsWith('WordPuppi admin — third-party notices')) throw new Error('Notices unavailable');
      if (!controller.signal.aborted) setText(value);
    }).catch(() => { if (!controller.signal.aborted) setError(true); });
    return () => controller.abort();
  }, [attempt]);
  return <main className="mx-auto max-w-5xl space-y-5 p-6">
    <h1 className="text-2xl font-semibold">About WordPuppi</h1>
    <h2 className="text-xl font-semibold">Third-party notices</h2>
    <p>WordPuppi uses open-source software. These notices accompany this build.</p>
    {error ? <div role="alert" className="space-y-3"><p>Could not load the notices.</p><Button variant="outline" onClick={() => setAttempt((value) => value + 1)}>Try again</Button></div> : text ? <pre tabIndex={0} aria-label="Third-party license notices" className="max-h-[70vh] overflow-auto whitespace-pre-wrap break-words rounded border p-4 text-sm">{text}</pre> : <p role="status">Loading notices…</p>}
  </main>;
}
